import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './styles.module.css';


import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { FaArrowDown, FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { sliderData as data, SliderItemType } from "./data";


import Item from "./Item/Item";
import { Link } from "react-scroll";
import { isRTL } from "src/utils/global";



const HeroSlider = () => {
  const { i18n, t } = useTranslation(['home']);

  return (
    <div className={`${styles.hero__con} ${isRTL() && styles.rtl}`}>
      <Slider {...SETTINGS}>
        {data.map((item: SliderItemType) => (
          <Item item={item} />
        ))}

      </Slider>
      <Link to={'aboutUs'} href='about' smooth={true} duration={600}
        className={`${styles.scrollBtn}`}>
        <FaArrowDown />
      </Link>
    </div>
  );
}

export default HeroSlider;

const SliderNextArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`slick-arrow slick-next ${styles.nextArrow}`}
      style={{ ...style }}
      onClick={onClick}

    >
      <FaChevronRight size={20} color="#fff" />
    </div>

  );
}

const SliderPrevArrow = (props: any) => {
  const { style, onClick } = props;
  return (
    <div
      className={`slick-arrow slick-prev ${styles.prevArrow}`}
      style={{ ...style }}
      onClick={onClick}
    >
      <FaChevronLeft size={20} color="#fff" />
    </div>
  );
}


const SETTINGS = {
  dots: false,
  fade: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  waitForAnimate: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  nextArrow: <SliderNextArrow />,
  prevArrow: <SliderPrevArrow />
};
